import { firstValueFrom, Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { AbstractCrudServiceMock } from './abstract-crud.service.mock';
import { Project } from '../../models/project';
import { ProjectServiceInterface } from '../project.service';

export const mockProjects: Project[] = [
    {
        id: 1,
        name: 'Stationstraat lantaarnpalen',
        requireVerification: false,
        code: 'P001',
        mapLayersData: [],
        configurationUrl: null,
        executorCanCreateObjects: true,
    },
    {
        id: 2,
        name: 'Kanaal Almelo',
        requireVerification: false,
        code: 'P002',
        mapLayersData: [],
        configurationUrl: null,
        executorCanCreateObjects: false,
    }
];

export class ProjectServiceMock extends AbstractCrudServiceMock<Project> implements ProjectServiceInterface {

    constructor() {
        super(mockProjects);
    }

    list(_: string): Observable<Project[]> {
        return this.getAll().pipe(
            map(response => response.content)
        );
    }

    get(id: number): Promise<Project> {
        return firstValueFrom(super.getImpl(id));
    }

    syncProjects(): Promise<void> {
        return Promise.resolve();
    }
}
